import { render } from "./CreateProjectFiles.vue?vue&type=template&id=70d757a1&scoped=true"
import script from "./CreateProjectFiles.vue?vue&type=script&lang=js"
export * from "./CreateProjectFiles.vue?vue&type=script&lang=js"

import "./CreateProjectFiles.vue?vue&type=style&index=0&id=70d757a1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d757a1"]])

export default __exports__